module.exports = __webpack_public_path__ + "static/Henrikki-dbfb6086cb312af172df2a413f1cd0bc.jpeg";